import {KeyValueTableRow} from './KeyValueTableRow'

import type {ReactNode} from 'react'

export interface KeyValueData {
  label: ReactNode
  data: ReactNode
}

export interface KeyValueTableProps {
  data: KeyValueData[]
  alignValue?: 'START' | 'END'
}

export const KeyValueTable = (props: KeyValueTableProps) => {
  const {
    data,
    alignValue = 'END',
  } = props

  return (
    <div className={'flex flex-col divide-y-1 divide-outline-secondary @container/block'}>
      {data.map((item, index) => (
        <KeyValueTableRow
          key={index}
          data={item}
          alignValue={alignValue}
        />
      ))}
    </div>
  )

}
